module.exports = __webpack_public_path__ + "img/laugh.a186c07b.png";